<template>
  <div class="content" :style="style" :class="{active}">
    <img 
      refs="img"
      class="image"
      :src="src"
      :srcset="srcset"
      :alt="alt">
  </div>
</template>

<script>
import { computed } from '@vue/composition-api'

export default {
  name: 'HomeGalleryImage',
  props: {
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  setup() {
    const getRandom = (min, max) => (Math.random() * (max - min) + min).toFixed(2)

    const style = computed(() => {
      return {
        width: `${getRandom(10, 15)}%`, 
        top:`${getRandom(10, 90)}%`, 
        left:`${getRandom(10, 90)}%`
      }
    })

    return {
      style
    }
  }
}
</script>

<style lang="scss" scoped>
  .content {
    position: absolute;
    pointer-events: none;
    transform: translate3d(-50%, -50%, 0);
    opacity: 0;
    transition: opacity 800ms $ease-out;

    &.active {
      opacity: 1;
    }

    &:after {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba($white, 0.6);
    }
  }

  .image {
    display: block;
    width: 100%;
    height: 100%;
  }
</style>